module.exports = __webpack_public_path__ + "img/logo-bej-sidebar.dd73961c.png";